import React, { useState, useRef } from 'react';
import './HeroSection.css';

const HeroSection = ({ onSearch, allTourNames = [] }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const inputRef = useRef(null);


  const handleSearch = (e) => {
    e.preventDefault();
    if (onSearch && searchQuery.trim()) {
      onSearch(searchQuery);
      setShowSuggestions(false);
    }
  };

  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
    setShowSuggestions(true);
  };

  const handleSuggestionClick = (name) => {
    setSearchQuery(name);
    setShowSuggestions(false);
    if (onSearch) onSearch(name);
    if (inputRef.current) inputRef.current.blur();
  };

  return (
    <section className="hero-section">
      <div className="hero-overlay">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Explore the World With Us</h1>
            <p className="hero-subtitle">
              Discover amazing destinations and create unforgettable memories
            </p>
            

            <form className="search-box" onSubmit={handleSearch} autoComplete="off" style={{ position: 'relative' }}>
              <input
                type="text"
                placeholder="Search for your dream destination..."
                value={searchQuery}
                onChange={handleInputChange}
                className="search-input"
                onFocus={() => setShowSuggestions(true)}
                ref={inputRef}
              />
              <button type="submit" className="search-button">
                🔍 Search
              </button>
              {showSuggestions && searchQuery && (
                <ul className="search-suggestions" style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  background: '#fff',
                  borderRadius: '2rem',
                  borderBottomRightRadius: '2rem',
                  borderTop: '1px solid #e0e0e0',
                  boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
                  zIndex: 10,
                  maxHeight: 220,
                  overflowY: 'auto',
                  margin: 0,
                  padding: 0,
                  listStyle: 'none',
                  borderLeft: '1px solid #e0e0e0',
                  borderRight: '1px solid #e0e0e0',
                }}>
                  {allTourNames.filter(name =>
                    name.toLowerCase().startsWith(searchQuery.toLowerCase())
                  ).slice(0, 8).map((name, idx, arr) => (
                    <li
                      key={name}
                      style={{
                        padding: '0.75rem 1.5rem',
                        cursor: 'pointer',
                        borderBottom: idx === arr.length - 1 ? 'none' : '1px solid #f0f0f0',
                        borderRadius: idx === arr.length - 1 ? '0 0 2rem 2rem' : 0,
                        background: '#fff',
                        transition: 'background 0.2s',
                        display: 'flex',
                        color:'#000000',
                        borderTopRightRadius: '2rem',
                        borderTopLeftRadius: '2rem'
                      }}
                      onMouseDown={() => handleSuggestionClick(name)}
                      onMouseOver={e => e.currentTarget.style.background = '#f5f7fa'}
                      onMouseOut={e => e.currentTarget.style.background = '#fff'}
                    >
                      {name}
                    </li>
                  ))}
                  {allTourNames.filter(name =>
                    name.toLowerCase().startsWith(searchQuery.toLowerCase())
                  ).length === 0 && (
                    <li style={{ padding: '0.75rem 1.5rem', color: '#aaa', borderRadius: '0 0 2rem 2rem' }}>No matches</li>
                  )}
                </ul>
              )}
            </form>
            
            <div className="hero-features">
              <div className="feature-item">
                <span className="feature-icon">✈️</span>
                <span>500+ Destinations</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">⭐</span>
                <span>Best Price Guarantee</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">🛡️</span>
                <span>Financial Protection</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
